import { object, ObjectSchema, string } from 'yup';

import { CompanySource, CompanySourceExternalReferenceValue } from '@client/api';

const schema: ObjectSchema<CompanySourceExternalReferenceValue> = object({
  integration: string<CompanySource>().required(),
  identifier: string().required()
});

export { schema as companySourceExternalReferenceValueSchema };
